import nodejsIcon from "@iconify-icons/logos/nodejs";
import goIcon from "@iconify-icons/logos/go";
import javascriptIcon from "@iconify-icons/logos/javascript";
import kotlinIcon from "@iconify-icons/logos/kotlin";
import reactIcon from "@iconify-icons/logos/react";
import mysqlIcon from "@iconify-icons/logos/mysql";
import bootstrapIcon from "@iconify-icons/logos/bootstrap";
import swiftIcon from "@iconify-icons/logos/swift";
import materialUi from "@iconify-icons/logos/material-ui";
import laravelIcon from "@iconify-icons/logos/laravel";
import phpIcon from "@iconify-icons/logos/php";
import dockerIcon from "@iconify-icons/vscode-icons/file-type-docker2";

const data = [
  { icon: nodejsIcon },
  { icon: goIcon },
  { icon: javascriptIcon },
  { icon: reactIcon },
  { icon: dockerIcon },
  { icon: kotlinIcon },
  { icon: mysqlIcon },
  { icon: bootstrapIcon },
  { icon: swiftIcon },
  { icon: materialUi },
  { icon: laravelIcon },
  { icon: phpIcon },
];

export default data;
